// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ja-0";
export var actionModalContentContainer = "_ja-1";